module.exports = __webpack_public_path__ + "img/Enmascarar grupo 23@2x.809a18f6.png";